module.exports = "/wwwroot/img/collection_vehicle_search_page.png?ver=4eba1d0d";